import { useLazyQuery } from '@apollo/client';
import { format, parseISO } from 'date-fns';
import { GRAPHQL_RELATORIO_SAQUES } from 'gql/saque';
import { useCreateCsv } from 'hooks/useCreateCsv';
import { formatarMoeda } from 'libs/NumberUtils';
import { useCallback, useContext, useRef } from 'react';
import { AuthContext } from 'routes/auth.context';

const formatarData = (valor?: string) =>
    valor ? format(parseISO(valor), 'dd/MM/yyyy HH:mm') : '';

export const useEntregadorRelatorioSaque = () => {
    const { alertConfirm } = useContext(AuthContext);
    const { handleGenerateCsv } = useCreateCsv();
    const currentDate = useRef({ dataInicio: '', dataFim: '' });

    const [handleQuery, { loading }] = useLazyQuery(GRAPHQL_RELATORIO_SAQUES, {
        fetchPolicy: 'network-only',
        onCompleted: (response) => {
            const content: any = [
                [
                    'Player',
                    'Qtd. coletas',
                    'Tx. retorno',
                    'Bônus',
                    'Frete',
                    'Valor a pagar',
                    'Tipo de PIX',
                    'Conta PIX',
                    'Tipo Pessoa',
                    'Cpf / Cnpj',
                    'Endereço',
                    'Número',
                    'Complemento',
                    'Bairro',
                    'Cep',
                    'Dados Atualizado',
                    'Taxa antecipação',
                    'Data solicitação',
                    'Pago?',
                    'Status',
                    'Data pagamento',
                ],
            ];

            response.relatorioSaques.forEach((props) => {
                content.push([
                    props.entregadorNome,
                    props.qtdeColetas,
                    formatarMoeda(props.valorTotalTaxaRetorno),
                    formatarMoeda(props.valorGarantido),
                    formatarMoeda(props.valorTotalFrete),
                    formatarMoeda(props.valorLiquido),
                    props.tipoPix,
                    props.chavePix,
                    props.tipoPessoa || '',
                    props.cpfCnpj || '',
                    props.endLogradouro || '',
                    props.endNumero || '',
                    props.endComplemento || '',
                    props.endBairro || '',
                    props.endCEP || '',
                    props.dadosAtualizado ? 'Sim' : 'Não',
                    formatarMoeda(props.taxaAntecipacao),
                    formatarData(props.dataSolicitacao),
                    props.status === 'CONCLUIDO' ? 'Sim' : 'Não',
                    props.statusDescricao || props.status,
                    formatarData(props.dataPagamento),
                ]);
            });

            handleGenerateCsv({
                fileName: `RELATÓRIO SAQUES ${currentDate.current.dataInicio} à ${currentDate.current.dataFim}`,
                content,
            });
        },
        onError: ({ message }) => {
            alertConfirm({
                tipo: 'erro',
                titulo: 'Erro',
                conteudo: message,
            });
        },
    });
    const handleClick = useCallback(
        (variables) => {
            currentDate.current = variables;
            handleQuery({
                variables: {
                    dataInicial: variables.dataInicio,
                    dataFinal: variables.dataFim,
                },
            });
        },
        [handleQuery]
    );
    return { handleClick, loading };
};
